export type ProductIdentifier = {
  productCode: string;
  productColour: string;
  fallbackProducts?: Array<{
    productCode: string;
    productColour: string;
  }>;
};
